export enum PlanningResolution {
  Weekly = 1,
  Daily = 2,
}
